import script from "./teamWorkerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./teamWorkerModal.vue?vue&type=script&setup=true&lang=js"

import "./teamWorkerModal.vue?vue&type=style&index=0&id=26e5d04c&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26e5d04c"]])

export default __exports__